import React, { useMemo } from "react";
import { X, Clock } from "lucide-react";
import { parseMDYDateTime } from "../utils/date";

export default function OrderEventsModal({
  open,
  onClose,
  loading,
  orderId,
  events = [],
}) {
  const sorted = useMemo(() => {
    const arr = Array.isArray(events) ? [...events] : [];
    // sort by time ascending (fallback: keep order)
    arr.sort((a, b) => {
      const da = parseMDYDateTime(a?.event_time)?.getTime?.() ?? 0;
      const db = parseMDYDateTime(b?.event_time)?.getTime?.() ?? 0;
      return da - db;
    });
    return arr;
  }, [events]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      {/* Backdrop */}
      <button
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-label="Close"
      />

      {/* Panel */}
      <div className="relative w-full max-w-xl rounded-2xl bg-white shadow-xl border">
        <div className="flex items-start justify-between gap-3 border-b px-5 py-4">
          <div>
            <div className="text-sm font-semibold text-gray-900">
              Order Delay Timeline
            </div>
            <div className="text-xs text-gray-500">Order ID: {orderId || "-"}</div>
          </div>

          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-xl border hover:bg-gray-50"
            title="Close"
          >
            <X size={16} />
          </button>
        </div>

        <div className="px-5 py-4">
          {loading ? (
            <div className="py-10 text-center text-sm text-gray-500">
              Loading events…
            </div>
          ) : sorted.length === 0 ? (
            <div className="py-10 text-center text-sm text-gray-500">
              No events found.
            </div>
          ) : (
            <div className="space-y-0">
              {sorted.map((ev, idx) => {
                const isLast = idx === sorted.length - 1;
                return (
                  <div key={`${ev?.event_id || idx}`} className="relative flex gap-3">
                    {/* Line + dot */}
                    <div className="flex flex-col items-center">
                      <div className="mt-1 h-3 w-3 rounded-full bg-emerald-500" />
                      {!isLast && <div className="mt-1 w-px flex-1 bg-gray-200" />}
                    </div>

                    {/* Content */}
                    <div className="pb-5">
                      <div className="text-sm font-semibold text-gray-900 capitalize">
                        {ev?.event_name || ev?.event_id || "Event"}
                      </div>
                      <div className="mt-1 inline-flex items-center gap-1 text-xs text-gray-600">
                        <Clock size={12} className="text-gray-500" />
                        {ev?.event_time || "-"}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="flex justify-end gap-2 border-t px-5 py-4">
          <button
            onClick={onClose}
            className="h-9 rounded-xl border px-4 text-xs font-semibold hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
